// extracted by mini-css-extract-plugin
module.exports = {"contentDiv":"DashBoard_contentDiv__3oFPM"};